import { useState, useEffect } from 'react';
import axios from 'axios';

// Recalculates cart pricing — applying any matching offers, same as the
// order-creation endpoint does — whenever the given cart items change.
// Shared by the Cart page, checkout Order Summary, and the header's cart
// total, so displayed pricing never drifts between places.
const useCartPricing = (cartItems) => {
    const [pricing, setPricing] = useState(null);

    useEffect(() => {
        const fetchPricing = async () => {
            if (!cartItems || cartItems.length === 0) {
                setPricing(null);
                return;
            }
            try {
                const { data } = await axios.post('/api/v1/calculate-cart-pricing', {
                    items: cartItems.map((item) => ({ product: item.product, quantity: item.quantity })),
                });
                setPricing(data);
            } catch (error) {
                console.error('Failed to calculate cart pricing', error);
            }
        };
        fetchPricing();
    }, [cartItems]);

    return pricing;
};

export default useCartPricing;
